// this function caluclates progress points for
// sections chosen by user. helps in calculating
// progress bar out of number.

export function getTotalProgressPoints(data) {
  let count = 0;
  data.forEach((item) => {
    if (item.isSelected == true) count += item.progressPoints;
  });

  return count;
}
